var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedFilterCount > 0)?_c('div',[_c('button',{staticClass:"btn btn-primary-outlined",on:{"click":_vm.resetFilters}},[_vm._v(" Reset Filters ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }